import { useFormikContext } from 'formik';
import React from 'react';
import { Messages } from '../../../../codegen/Localize';
import { FormikCheckbox } from '../../../../commonInfra/components/FormikCheckbox';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { SettingsSection } from '../../../components/common/SettingsSection';
import { groupNameMessage, warningText } from '../../../styles/CommonStyles';
import { SiteSettingsForSiteAdminProps } from '../site-settings/ReactSiteSettingsForSiteAdmin';
import { componentRegistryEntry } from '../SettingsComponentRegistryFunctions';
import { forceUncheckedIfUserVisibilityLimited, useUserVisibilityLimited } from './UserVisibilitySection';

export const PUBLIC_COLLECTIONS_FIELD = 'settings.publicCollectionsEnabled';

export type CollectionsSectionProps = SiteSettingsForSiteAdminProps<'publicCollectionsEnabled' | 'userVisibility'>;

export function CollectionsSection() {
  const formik = useFormikContext<CollectionsSectionProps>();
  const initiallyChecked = formik.initialValues.settings.publicCollectionsEnabled;
  const currentValue = formik.values.settings.publicCollectionsEnabled;
  const shouldRenderWarning = initiallyChecked && !currentValue;
  const isUserVisibilityLimited = useUserVisibilityLimited();

  return FeatureFlags.collectionsEnabled && !FeatureFlags.collectionsPermissionsEnabled
    ? (
      <SettingsSection title={renderTitle(isUserVisibilityLimited)}
                       testId={'collections-site-setting'}
                       description={Messages.collectionsSettingsMessage()}
                       disabled={isUserVisibilityLimited}>
        <FormikCheckbox name={PUBLIC_COLLECTIONS_FIELD}
                        label={Messages.collectionsSettingPublicEnabled()}
                        testId={'public-collections-enabled'}
                        disabled={isUserVisibilityLimited}
                        {...forceUncheckedIfUserVisibilityLimited(isUserVisibilityLimited)}>
        </FormikCheckbox>
        {shouldRenderWarning &&
          <div className={warningText} data-tb-test-id='private-collections-warning'>
            {Messages.collectionsSettingPublicDisabledWarning()}
          </div>
        }
      </SettingsSection>
    )
    : null;
}

function renderTitle(userVisibilityLimited: boolean) {
  return <>
    <span>{Messages.collections()}</span>
    {userVisibilityLimited &&
    <span className={groupNameMessage} data-tb-test-id={'collections-uservisibility-warning'}>
      {Messages.userVisibilityWarning()}
    </span>}
  </>;
}

export const CollectionsSectionSpecs = componentRegistryEntry({
  name: 'CollectionsSection',
  component: CollectionsSection
});
